import React from "react";
import { useMutation } from "react-query";
import { addCustomReport } from "../../../../actions/Utilities/CustomReport";

const useAddCustomReports = () => {
  return useMutation(addCustomReport);
};

export default useAddCustomReports;
